<template>
  <div>
    <!--头部-->
    <header>
      <div>
        <div class="tou">
          <div class="touArea" style="display: flex;justify-content: space-between;">
            <span>{{language.notice1}}</span>
            <div style="display: flex;">
              <span style="margin-right: 30px;">{{language.notice2}}</span>
              <languageSelect></languageSelect>
            </div>
          </div>
        </div>
        <div class="top-1">
          <div class="logo clearfix">
            <router-link to="index">
              <img src="static/images/logo.png" />
            </router-link>
          </div>
          <!--导航-->
          <nav>
            <li v-for="(item,index) in menuList" :key="index" :class="{'active':acticeMenu==index}">
              <div @click="toRouter(index,item.router)">{{item.title}}</div>
            </li>
          </nav>
        </div>
      </div>
    </header>
    <!--头部-->
    <div style="display: none;">{{language}}</div>
  </div>
</template>

<script>
  import languageSelect from './language.vue'
  export default {
    components:{
      languageSelect
    },
    data() {
      return {
        menuList:[
          {
            code:'index',
            title:'首页',
            router:'index'
          },
          {
            code:'about',
            title:'关于我们',
            router:'about'
          },
          {
            code:'product',
            title:'产品展示',
            router:'product'
          },
          {
            code:'career',
            title:'诚募英才',
            router:'career'
          },
          {
            code:'achievement',
            title:'工程业绩',
            router:'achievement'
          },
          {
            code:'contact',
            title:'联系我们',
            router:'contact'
          }
        ],
        acticeMenu:0,
      }
    },
    computed:{
      language() {
        let header = this.$store.state.language.header
        for (let i = 0; i < this.menuList.length; i++) {
          let menu = this.menuList[i];
          let navText = header[menu.code]
          if(navText){
            menu.title = navText
          }
        }
        return header
      }
    },
    watch:{
      '$route.path'(toPath, fromPath){
          let routerName = toPath.slice(1);
          if(routerName=="productDetail"){
            routerName="product"
          }else if(routerName=="achievementDetail"){
            routerName="achievement"
          }
          for (let i = 0; i < this.menuList.length; i++) {
            let menu = this.menuList[i]
            if(menu.router==routerName){
              this.acticeMenu=i
            }
          }
       },
    },
    methods: {
      toRouter(index,router){
        // this.acticeMenu = index;
        this.$router.push('/'+router)
      }
    },
    created() {
    },
    destroyed() {}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/header.vue